import { useRef } from "react";
import { Divider, Button, Flex, notification } from "antd";
import FaturaFormBasic, { IFaturaFormBasicProps, IFaturaFormBasicRef } from "./FaturaFormBasic";
import { useFaturaSalvar, useFaturaBuscar } from "@/Services/Financeiro/Titulo/FaturaService";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";
import APagarLancamentoForm from "../APagar/lancamento/APagarLancamentoForm";
import AReceberLancamentoForm from "../AReceber/lancamento/AReceberLancamentoForm";

export interface IFaturaFormProps extends IFaturaFormBasicProps {
    onSucess?: (codFatura: number | null) => void;
}

export default function FaturaForm({
    codigo,
    onSucess,
    isAReceber,
    ...props
}:IFaturaFormProps) {
    const refForm = useRef<IFaturaFormBasicRef|null>(null);

    const {
        mutate,
        isPending
    } = useFaturaSalvar({
        onSuccess(data, variables, context) {
            const codTitulo = refForm.current?.getFieldValue("isAlteracao") ? codigo : data.data;
            onSucess?.(codTitulo ?? null);

            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : `Título ${(codigo ?? 0) > 0 ? "alterado" : "cadastrado"} com sucesso, agora é preciso cadastrar as parcelas do título ${codTitulo}.`
            });
        },
    });

    if (isAReceber === false) return <APagarLancamentoForm 
        codigo={codigo}
        popular={true}
        isButtonCancelar
        onSuccess={(v) => onSucess?.(v?.titulo?.codigo ?? null)}
    />

    return <AReceberLancamentoForm 
        codigo={codigo}
        popular={true}
        isButtonCancelar
        onSuccess={(v) => onSucess?.(v?.titulo?.codigo ?? null)}
    />
    
    return <>
        <FaturaFormBasic 
            {...props}
            ref={refForm}
            codigo={codigo}
            isAReceber={isAReceber}
            onFinish={(data) => {
                // alert(`IsAlteracao: ${data.isAlteracao ? "Sim" : "Não"}`);
                if (data.isAlteracao) data.fatura.codigo = codigo ?? 0;

                mutate({
                    ...data,
                    isAReceber: isAReceber ?? false
                });
            }}
        />
        <Divider />
        <Flex gap="small" wrap="wrap" justify="center">
            {/* {!!buttoCencelar && buttoCencelar}
            {!!!buttoCencelar && !!onCancelar && (
                <Button type="primary" danger htmlType="reset" onClick={onCancelar}>
                    Cancelar
                </Button>
            )} */}
            <Button type="primary" onClick={() => refForm.current?.submit()} loading={isPending}>
                Salvar
            </Button>
        </Flex>
    </>
}